module.exports = __webpack_public_path__ + "img/CardImage3.f1908942.png";